import React, { useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'underscore';
import { message } from 'antd';
import SelectorWrapper from './selectorWrapper';
import styles from './index.module.scss';
import { initUrlParams, stringifySearch } from '../../../../utils';
import { changeBrand_IdToName } from '../../../../utils/ev';

const prefix = '//img30.360buyimg.com/popshop/'

function Selector() {

  const { pathname } = useLocation();
  const history = useHistory();

  const {
    brands,
    extCates,
    advancedCates,
    mulFilter,
    mulBtnIdx,
    moreBtnIdxs,
    urlParams,
    categorys,
    crumb
  } = useSelector(state => state.searchReducer);

  const [checkedValues, setCheckedValues] = useState([]);
  const [adCateIdx, setAdCateIdx] = useState(-1);
  const filterOptRef = useRef({})

  const handleNormalFilter = _.debounce((value, type = 'other') => {
    const valueArr = value.split('_');
    const name = valueArr.splice(valueArr.length - 1, 1);
    const evValue = valueArr.join('_');
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    let _pathname = pathname.replace(/\//g,'');
    // initUrlParams(_searchParamsBody)
    if (type === '品牌') {
      _searchParamsBody.brands = _searchParamsBody.brands ? [...new Set([...(_searchParamsBody.brands), name[0]])] : [name[0]];
    } else {
      _searchParamsBody.extAttrs = _searchParamsBody.extAttrs ? [...new Set([...(_searchParamsBody.extAttrs), evValue])] : [evValue];
    }
    if(window.location.pathname.indexOf('list.html') !== -1){
      // const { ev = '' } = _searchParamsBody;
      // const exbrand = ev.match(/exbrand_\d+/g);
      // const crumbBrand = crumb.filter(crumbItem => crumbItem.crumbName === '品牌');
      // if(exbrand?.length !== 0 && crumbBrand.length !== 0){
      //   const brandId = exbrand[0].split('_')[1];
      //   const crumbName = crumb.filter(crumbItem => crumbItem.crumbName === '品牌')[0]?.content[0];
      //   _searchParamsBody.ev = ev.replace(brandId, crumbName)
      // }
      _searchParamsBody.ev = changeBrand_IdToName(_searchParamsBody, crumb)
      _searchParamsBody.keyword =  `catid_str,,${categorys?.[1]?.cid3[0]?.id}`;
      window.location.href = `${window.location.origin}/search?${stringifySearch(_searchParamsBody)}`
    }else{
      history.push({
        pathname: _pathname,
        search: stringifySearch(_searchParamsBody)
      })
    }
    
  }, 1000)

  const handleMulFilter = (value, extCateIdx) => {
    if (mulFilter && mulBtnIdx === extCateIdx) {
      let _checkedValues = [...checkedValues];
      if (_checkedValues.includes(value)) {
        _checkedValues = _checkedValues.filter(item => item !== value);
        setCheckedValues(_checkedValues)
      } else {
        if (_checkedValues.length < 5) {
          _checkedValues = [..._checkedValues, value];
          setCheckedValues(_checkedValues)
        } else {
          message.info("已选条件不能大于5个")
        }
      }

    }
  }

  const handleMouseEnter = (index, e) => {
    e.stopPropagation();
    setAdCateIdx(index)
  }

  const handleMouseLeave = (e) => {
    e.stopPropagation();
    adCateIdx !== -1 && setAdCateIdx(-1)
  }


  return (
    <div className="w">
      <div className={styles.selector}>
        {
          brands.length > 1 && (
            <SelectorWrapper name={"品牌"} index={0} checkedValues={checkedValues} changeCheckedValues={setCheckedValues} listsRef={filterOptRef}>
              {
                mulFilter && mulBtnIdx === 0 && <ul className={styles["sl-b-letter"]}>
                  <li className={styles.cur} key={"all"}>所有品牌</li>
                </ul>
              }
              <div className='clr'></div>
              <div className={styles["sl-brand-list"]}>
                <ul style={(mulFilter && mulBtnIdx === 0) || moreBtnIdxs[0] ? { overflowY: 'scroll', height: '150px' } : {}} ref={el => filterOptRef.current[0] = el}>
                  {
                    brands.map((brand) => {
                      const brandValue = `${brand.id}_${brand.name}`;
                      return (
                        <li onClick={mulFilter && mulBtnIdx === 0 ? () => handleMulFilter(brandValue, 0) : () => handleNormalFilter(brandValue, '品牌')} key={brand.id}>
                          <div style={checkedValues.includes(brandValue) ? { border: '1px solid #7d256e', zIndex: 2 } : {}}>
                            <i style={{ visibility: checkedValues.includes(brandValue) ? 'visible' : 'hidden' }}></i>
                            <span>
                              {/* {brand.logoUrl && <img src={prefix + `${brand.logoUrl.indexOf('popshop') == -1 ? brand.logoUrl : brand.logoUrl.slice(7)}`} alt="" />} */}
                              {brand.logoUrl && <img src={brand.logoUrl.indexOf("360buyimg.com") != -1 ? brand.logoUrl : prefix + brand.logoUrl} alt="" />}
                            </span>
                            <em>{brand.name}</em>
                          </div>
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
            </SelectorWrapper>
          )
        }
        {
          extCates.length > 0 && extCates.map((extCate, extCateIdx) => {
            const _extCateIdx = brands.length ? extCateIdx + 1 : extCateIdx;
            return (
              <SelectorWrapper name={extCate.name} key={extCate.id} index={_extCateIdx} checkedValues={checkedValues} changeCheckedValues={setCheckedValues} listsRef={filterOptRef}>
                <div className={styles["sl-v-list"]}>
                  <ul style={(mulFilter && mulBtnIdx === _extCateIdx) || moreBtnIdxs[_extCateIdx] ? { height: 'auto' } : {}} ref={el => filterOptRef.current[_extCateIdx] = el}>
                    {
                      extCate.extAttrs.map((extAttr) => {
                        const extAttrValue = `${extCate.id}_${extAttr.id}_${extAttr.name}`;
                        return (
                          mulFilter && mulBtnIdx === _extCateIdx ?
                            <li key={extAttr.id} onClick={() => handleMulFilter(extAttrValue, _extCateIdx, extCate.name)} style={{ paddingLeft: '18px' }}>
                              <i style={checkedValues.includes(extAttrValue) ? { borderColor: '#e2231a', backgroundPosition: '2px -106px' } : {}}></i>
                              <span>{extAttr.name}</span>
                            </li>
                            :
                            <li key={extAttr.id} onClick={() => handleNormalFilter(extAttrValue, extCate.name)}>
                              <span>{extAttr.name}</span>
                            </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </SelectorWrapper>
            )
          })
        }
        {
          advancedCates.length > 0 && <>
            <SelectorWrapper name={"高级选项"} checkedValues={checkedValues} changeCheckedValues={setCheckedValues} handleMouseLeave={handleMouseLeave}>
              <div className={styles["sl-v-tab"]}>
                <ul>
                  {
                    advancedCates.map((item, index) => <li key={item.id} onMouseEnter={(e) => handleMouseEnter(index, e)} className={adCateIdx === index ? styles["sl-v-tab-cur"] : null}>{item.name}<i></i></li>)
                  }
                </ul>
              </div>
              <div className={styles["sl-v-content"]}>
                {
                  advancedCates.map((advancedCate, advancedCateIdx) => {
                    const _advancedCateIdx = extCates.length + advancedCateIdx + (brands.length ? 1 : 0);
                    return (
                      <div className={styles["sl-v-content-item"]} style={{ display: adCateIdx === advancedCateIdx ? 'block' : 'none' }} key={advancedCate.id}>
                        <SelectorWrapper name={advancedCate.name} index={_advancedCateIdx} checkedValues={checkedValues} changeCheckedValues={setCheckedValues} showKey={false} listsRef={filterOptRef}>
                          <ul className={styles["sl-v-list"]} ref={el => filterOptRef.current[_advancedCateIdx] = el}>
                            {
                              advancedCate.extAttrs.map((extAttr) => {
                                const extAttrValue = advancedCateIdx >= 9 ? `${extAttr.id}_${extAttr.name}` : `${advancedCate.id}_${extAttr.id}_${extAttr.name}`;
                                return (
                                  mulFilter && mulBtnIdx === _advancedCateIdx ?
                                    <li key={extAttr.id} onClick={() => handleMulFilter(extAttrValue, _advancedCateIdx)} style={{ paddingLeft: '18px' }}>
                                      <i style={checkedValues.includes(`${advancedCate.id}_${extAttr.id}_${extAttr.name}`) ? { borderColor: '#e2231a', backgroundPosition: '2px -106px' } : {}}></i>
                                      <span>{extAttr.name}</span>
                                    </li>
                                    :
                                    <li key={extAttr.id} onClick={() => handleNormalFilter(extAttrValue, advancedCate.name)}>
                                      <span>{extAttr.name}</span>
                                    </li>
                                )
                              })
                            }
                          </ul>
                        </SelectorWrapper>
                      </div>
                    )
                  })
                }
              </div>
            </SelectorWrapper>
          </>
        }
      </div>
    </div >
  )
}

export default Selector;